import { InputText } from "primereact/inputtext";
import { useContext } from "react";
import { ModuleRatingDetailsContext } from "../../module-rating-details.context";

export const ModuleRatingDetailsTableFilters = () => {
	const { oneKeyId, setOneKeyId } = useContext(ModuleRatingDetailsContext);

	return (
		<div className={"flex gap-2"}>
			<InputText
				className="m-1 w-21rem"
				value={oneKeyId}
				onChange={(e) => {
					const newValue = e.currentTarget.value ?? "";
					setOneKeyId(newValue);
				}}
				placeholder={"OneKeyId"}
			/>
		</div>
	);
};
